<template>
  <div v-if="inputedValue.dialog && pageData.length > 0 && dataLoaded">
    <ShipDeliveryDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      @complete="complete"
      isCardColor="true"
    >
      <template v-slot:[pageData[0].name]>
        <ShipDeliveryContentTable
          :headers="pageData[0].headers"
          :items="recItems.productMoves"
        >
          <template v-slot:productName="{ item }">
            <div>
              {{ item.product.nameJp }}
            </div>
            <div>
              {{ item.product.nameCn }}
            </div>
          </template>
          <template v-slot:quantityDate="{ item }">
            <QuantityDate
              :dateList="
                productInputData[getProductInputDataIndex(item.productMoveId)]
                  .rackNumberList
              "
              @change="onChangeQuantityRackNumber(item.productMoveId, $event)"
              class="py-1"
              :defaultQuantity="
                productInputData[getProductInputDataIndex(item.productMoveId)]
                  .notYet
              "
            />
          </template>
          <template v-slot:stockQuantity="{ item }">
            {{ getRackInfo(item) }}
          </template>
          <template v-slot:productCapacity="{ item }">
            {{ getProductCapacity(item) }}
          </template>
          <template v-slot:expandFooter="{ item }">
            <v-container fluid>
              <v-row justify="end" class="ma-1">
                <div class="ma-2 btnStyle">
                  <NormalButton
                    :text="$t('common.input_order-send')"
                    textSize="16px"
                    height="40px"
                    width="120px"
                    btnClass="ml-auto"
                    @click="saveProductData"
                  />
                </div>
              </v-row>
            </v-container>
          </template>
        </ShipDeliveryContentTable>
      </template>
      <template v-slot:[pageData[1].name]="{ item }">
        <ShipDeliveryHistoryTable
          v-if="pageData[1].items && pageData[1].items.length > 0"
          :headers="pageData[1].headers"
          :subHeaders="pageData[1].subTable.headers"
          :propsItems="pageData[1].items"
          :recItems="recItems"
          :item-key="pageData[1].itemKey"
        >
        </ShipDeliveryHistoryTable>
      </template>
      <template v-slot:[pageData[2].name]>
        <OperationDetail
          :recItems="recItems"
          :type="pageType.en"
          :isEdit="isEdit"
          :isTotalAmount="isTotalAmount"
        >
          <template #button v-if="isHistoryType">
            <slot :name="pageData[2].buttonAreaName" />
          </template>
        </OperationDetail>
      </template>
    </ShipDeliveryDialogBase>
  </div>
</template>

<script>
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import OrderIncompleteDialogBase from '@/components/layouts/Dialogs/MultipleArea/OrderIncompleteDialog/OrderIncompleteDialogBase'
import { mapActions, mapGetters } from 'vuex'
import ShippingHistoryTable from '@/components/items/Tables/ShippingHistoryTable'
import ShipDeliveryContentTable from '@/components/items/Tables/ShipDeliveryContentTable'
import ShipDeliveryDialogBase from '@/components/layouts/Dialogs/MultipleArea/ShipDeliveryDialog/ShipDeliveryDialogBase'
import ShipDeliveryHistoryTable from '@/components/items/Tables/ShipDeliveryHistoryTable'
import QuantityDate from '@/components/items/Designs/QuantityDate'
import NormalButton from '@/components/items/Buttons/NormalButton'
import { storageUtil } from '@/util'
import headers from '@/views/sales/History/headers'

export default {
  name: 'ShipDeliveryDialog',
  components: {
    QuantityDate,
    ShipDeliveryHistoryTable,
    ShipDeliveryDialogBase,
    ShipDeliveryContentTable,
    ShippingHistoryTable,
    OrderIncompleteDialogBase,
    OperationDetail,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },
    isEdit: { default: false },
    isTotalAmount: { default: true },
    isHistoryType: { default: true },
    dialogReload: { default: 0 }
  },
  data: () => ({
    pageData: [],
    productInputData: [],
    storage: {},
    productListForRackNumber: [],
    allRackNumberList: [],
    dataLoaded: false,
    historyList: [],
    listShippedProducts: [],
    pageType: {
      en: 'sale',
      ja: '注文'
    }
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  created() {},
  watch: {
    inputedValue: {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.dialog) await this.init()
      }
    },
    dialogReload: async function (val) {
      if (val) await this.init()
    }
  },
  methods: {
    ...mapActions('Ship', [
      'getShipHistoryListByIdFromApi',
      'getShipListFromApi'
    ]),
    ...mapGetters('Ship', [
      'getShipListFromState',
      'getShipDeliveryListFromState'
    ]),
    ...mapActions('Sale', [
      'getRackNumberByProductFromApi',
      'shipmentDelivery'
    ]),
    ...mapGetters('Sale', ['getRackNumberByPaymentFromState']),
    async init() {
      await this.ini()
      await this.setProductListForRackNumber()
      await this.setRackNumber()
      await this.setProductInputData()
      this.dataLoaded = true
    },
    async ini() {
      const ShipDeliveryHistoryList = await this.getShipHistoryListByIdFromApi({
        id: this.recItems.saleId
      })
      this.setListShippedProducts()
      this.historyList = ShipDeliveryHistoryList.data.map((ele, Index) => {
        ele.panelIndex = Index + 1
        return ele
      })
      this.pageData = [
        {
          title: 'sale.ship_ship-delivery-notification',
          name: 'ShipDeliveryContent ',
          buttonName: 'common.input_order-send',
          itemKey: 'shipId',
          headers: [
            {
              text: 'common.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '135px',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '600px'
            },
            {
              text: 'common.product_capacity',
              value: 'productCapacity',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'sale.sale_number-of-sales',
              value: 'quantity',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'storage.storage_stock-quantity',
              value: 'stockQuantity',
              sortable: false,
              width: '88px',
              align: 'center'
            },
            {
              text: 'common.common_product-quantity_shipping-date_delivery-date',
              value: 'quantityDate',
              sortable: false,
              width: '470px'
            }
          ],
          items: ShipDeliveryHistoryList.data
        },
        {
          title: 'sale.ship_ship-delivery-notification-history',
          name: 'ShipDeliveryHistory',
          itemKey: 'shipHistoryId',
          headers: [
            {
              text: 'ship.ship_notification-date',
              value: 'notificationDate',
              sortable: false,
              width: '150px'
            },
            {
              text: 'ship.ship_sender',
              value: 'createdBy',
              sortable: false,
              width: '120px'
            }
          ],
          subTable: {
            title: 'sale.ship_ship-delivery-notification',
            name: 'ShipDeliveryHistorySubTable',
            itemKey: 'subTableId',
            headers: [
              {
                text: 'common.product_product-number',
                value: 'product.productId',
                sortable: false,
                width: '135px'
              },
              {
                text: 'common.product_product-name',
                value: 'product.nameJp',
                sortable: false,
                width: '600px'
              },
              {
                text: 'common.product_capacity',
                value: 'product.capacity',
                sortable: false,
                width: '88px'
              },
              {
                text: 'product.product_quantity',
                value: 'quantity',
                sortable: false,
                width: '88px'
              },
              {
                text: 'common.common_shipping-date',
                value: 'shippingDate',
                sortable: false
              },
              {
                text: 'common.common_delivery-date',
                value: 'deliveryDate',
                sortable: false
              }
            ]
          },
          items: ShipDeliveryHistoryList.data
        },
        {
          title: 'common.input_sale-details',
          name: 'operationDetail',
          buttonAreaName: 'operationDetailbuttonArea',
          headers: headers.productListHeaders,
          items: [],
          footers: [],
          itemKey: this.recItems.saleId
        }
      ]
    },
    setListShippedProducts() {
      this.listShippedProducts = []
      const shipList = this.getShipDeliveryListFromState()
      for (let i = 0; i < shipList.length; i++) {
        const products = shipList[i].products
        for (let j = 0; j < products.length; j++) {
          for (let k = 0; k < products[j].rackProductList.length; k++) {
            const shippedProduct = products[j].rackProductList[k]
            shippedProduct.productId = products[j].product_id
            this.listShippedProducts =
              this.listShippedProducts.concat(shippedProduct)
          }
        }
      }
    },
    getProductInputData(productMoveId, propertyName) {
      const rec =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return rec[propertyName]
    },
    async setProductInputData() {
      this.productInputData = this.recItems.productMoves.map((ele) => {
        const doneLengt = this.getDone(ele)
        const notYetLengt = ele.quantity - doneLengt
        return {
          productId: ele.product.productId,
          productMoveId: ele.productMoveId,
          productName: ele.product.productName,
          productCapacity: ele.product.productCapacity,
          productQuantity: ele.product.productQuantity,
          done: doneLengt,
          notYet: notYetLengt,
          rackInfoList: [],
          rackNumberList: this.getRackNumberList(
            this.allRackNumberList,
            ele.product.productId,
            notYetLengt
          )
        }
      })
      const ret = this.productInputData.filter((ele) => ele.notYet > 0)
      this.isPossibleOperation = ret.length > 0
    },
    getRackNumberList(allRackNumberList, productId, notYet) {
      // 対象商品が管理されている棚番号一覧
      const rackInfoList = allRackNumberList
        .filter((ele) => ele.rackInfoList.length > 0)
        .map((ele) => {
          // ele.rackInfoList = ele.rackInfoList.filter((ele) => ele.rackNumber)
          return ele
        })
        .find((v) => {
          return v.productId === productId
        })
        ?.rackInfoList.map((rackInfo, index) => {
          return { ...rackInfo, count: index === 0 ? notYet : 0 }
        })

      return rackInfoList
        ? rackInfoList
        : [
            {
              rackNumber: '',
              quantity: 0,
              count: 0
            }
          ]
    },
    async setProductListForRackNumber() {
      const itemsTmp = await storageUtil.getStorageIdNameList()
      if (itemsTmp && itemsTmp.data.length > 0) {
        this.storage = itemsTmp.data[0]
      }

      // 対象販売履歴に紐づく全商品の棚番号一覧を取得
      const productIdList = this.recItems.productMoves.map((ele) => {
        return ele.product.productId
      })

      if (this.storage.value) {
        await this.getRackNumberByProductFromApi({
          storageId: this.storage.value,
          productIdList: productIdList
        })
      }

      this.productListForRackNumber = this.getRackNumberByPaymentFromState()
    },
    async setRackNumber() {
      this.allRackNumberList = this.productListForRackNumber.map((ele) => {
        return {
          productId: ele.productId,
          rackInfoList: ele.rackInfoList
        }
      })
    },
    getDone(saleProductMoves) {
      const targetList = this.listShippedProducts.filter(
        (ele) => ele.productId === saleProductMoves.product.productId
      )
      return targetList.reduce((result2, current2) => {
        return result2 + current2.quantity
      }, 0)
    },
    getRackInfo(item) {
      const rec =
        this.productInputData[this.getProductInputDataIndex(item.productMoveId)]
          .rackNumberList
      let totalStockQuantity = 0
      rec.forEach((item) => {
        totalStockQuantity += item.quantity
      })
      return totalStockQuantity
    },
    getProductCapacity(item) {
      return item.product.capacity ? item.product.capacity : '-'
    },
    onChangeQuantityRackNumber(productMoveId, event) {
      const rackInfoList = event
      this.updateProductData(productMoveId, 'rackInfoList', rackInfoList)
    },
    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },
    updateProductData(productMoveId, updatePropertyNameName, updateData) {
      this.productInputData = this.productInputData.map((ele) => {
        if (ele.productMoveId === productMoveId) {
          ele[updatePropertyNameName] = updateData
        }
        return ele
      })
    },
    async saveProductData() {
      const params = {
        saleId: this.recItems.saleId,
        productList: this.productInputData
      }
      const isSucceed = await this.shipmentDelivery(params)
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.$emit('complete')
      }
    },
    complete() {
      this.$emit('complete')
    }
  }
}
</script>

<style scoped></style>
